import L from "leaflet";

class MarkerIconService {

    public OPERATION_INSTALLATION_EQUIPMENT_ICON_PATH = 'assets/icon/construction.svg';
    public OPERATION_INSTALLATION_ELEMENT_ICON_PATH = 'assets/icon/add.svg';
    public OPERATION_UNINSTALL_EQUIPMENT_ICON_PATH = 'assets/icon/remove.svg';
    public OPERATION_UNINSTALL_ELEMENT_ICON_PATH = 'assets/icon/remove_element.svg';
    public OPERATION_REPLACE_ELEMENT_ICON_PATH = 'assets/icon/replace.svg';
    public OPERATION_GEOLOCATE_ICON_PATH = 'assets/icon/add_location.svg';

    public BASIC_LOCATION_ICON_PATH = 'assets/icon/location.svg';

    /**
     * Allows you to generate a custom marker icon
     * @param urlIcon the url of the image to display
     * @param cssClassName
     */
    public generateIcon(urlIcon: string, cssClassName: string) {
        return new L.Icon({
            iconUrl: urlIcon,
            iconRetinaUrl: urlIcon,
            iconAnchor: undefined,
            shadowUrl: undefined,
            shadowAnchor: undefined,
            iconSize: new L.Point(25,35),
            className: cssClassName
        });
    }

    public getBasicIcon() {
        return this.generateIcon(
            this.BASIC_LOCATION_ICON_PATH,
            ""
        );
    }

}

export default new MarkerIconService();
